import { memo } from "react";
import { Grid, Box, Typography, TextField } from "@material-ui/core";
import dayjs from "dayjs";
import { DatePicker } from "@material-ui/lab";

/**
 * Componente para seleccionar un año usando un DatePicker elegante
 * Muestra solo vista de año, sin mes ni día
 *
 * @param {Object} props
 * @param {string} props.id - ID del componente
 * @param {string} props.label - Etiqueta descriptiva
 * @param {Date} props.anioSeleccionado - Año actualmente seleccionado (objeto Date)
 * @param {function} props.onChangeAnio - Callback cuando cambia el año
 * @param {number} props.tamanio - Tamaño del Grid (1-12)
 * @param {boolean} props.required - Si el campo es requerido
 * @param {string} props.variant - Variante del TextField ("outlined", "filled", "standard")
 * @param {string} props.size - Tamaño del TextField ("small", "medium")
 * @param {Date} props.minDate - Fecha mínima seleccionable (default: 2021)
 * @param {Date} props.maxDate - Fecha máxima seleccionable (default: año actual)
 */
const AnioFilter = memo(
  ({
    id = "anio-filter",
    label = "Filtrar por año",
    anioSeleccionado,
    onChangeAnio,
    tamanio = 12,
    required = false,
    variant = "outlined",
    size = "small",
    minDate = new Date(2021, 0, 1), // 1 de enero de 2021
    maxDate = new Date(), // Fecha actual
    ...other
  }) => {
    const handleChange = (date) => {
      if (date && dayjs(date).isValid()) {
        onChangeAnio(date);
      }
    };

    return (
      <Grid item xs={tamanio} {...other}>
        <Box>
          {label && (
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {label}
            </Typography>
          )}

          <DatePicker
            id={id}
            value={anioSeleccionado}
            onChange={handleChange}
            views={["year"]} // Solo mostrar vista de año
            label="Año"
            format="YYYY"
            minDate={minDate}
            maxDate={maxDate}
            autoOk // Cerrar automáticamente al seleccionar
            variant="inline"
            inputVariant={variant}
            size={size}
            required={required}
            fullWidth
            helperText={`Mostrando datos del año ${dayjs(
              anioSeleccionado,
            ).year()}`}
            renderInput={(params) => <TextField {...params} />}
          />
        </Box>
      </Grid>
    );
  },
);

AnioFilter.displayName = "AnioFilter";

export default AnioFilter;
